<header class="header">
	<div class="container">
		<nav class="navbar">
			<div class="container-fluid">
				<a class="navbar-brand">
					<img src="../assets/img/logo.png" class="logo" />
				</a>
				<div class="d-flex">
					<div ngbDropdown class="d-inline-block">
						<button type="button" class="btn dropdown-toggle" id="dropdownBasic1" ngbDropdownToggle>
							{{ language | uppercase }}
						</button>
						<div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-end">
							<button ngbDropdownItem (click)="useLanguage('ca')">CA</button>
							<button ngbDropdownItem (click)="useLanguage('es')">ES</button>
							<button ngbDropdownItem (click)="useLanguage('en')">EN</button>
						</div>
					</div>
				</div>
			</div>
		</nav>
	</div>
</header>

<div class="container-stepper" *ngIf="isValidToken" (showC2CButton)="onShowC2CButton($event)">
	<button
		*ngIf="showC2CButton"
		type="button"
		class="btn btn-float-call d-flex align-items-center justify-content-center w-100 w-md-initial"
		(click)="showClickToCall()"
	>
		<i class="icon hs-icon-call"></i>
		<div class="btn-float-call-text ms-2 text-start d-sm-flex flex-column min-width-140">
			<span>{{ 'clickToCall.floatBtnQuestion' | translate }}</span>
			<span class="fw-bold">{{ 'clickToCall.buttonMsg' | translate }}</span>
		</div>
	</button>

	<div class="container" *ngIf="showStepper">
		<mat-stepper labelPosition="bottom" #stepper class="stepper stepper-horizontal" animationDuration="0">
			<mat-step>
				<p class="step-number">Paso 1 de 4</p>
				<ng-template matStepLabel>{{ 'headers.contactData' | translate }}</ng-template>
				<ng-template matStepContent>
					<datos-contacto (nextStep)="onNextStep()" (showC2CButton)="onShowC2CButton($event)" (showStepper)="onShowStepper($event)"></datos-contacto>
				</ng-template>
			</mat-step>

			<mat-step>
				<p class="step-number">Paso 2 de 4</p>
				<ng-template matStepLabel>{{ 'headers.claimData' | translate }}</ng-template>
				<ng-template matStepContent>
					<datos-siniestro (nextStep)="onNextStep()" (showC2CButton)="onShowC2CButton($event)"></datos-siniestro>
				</ng-template>
			</mat-step>

			<mat-step>
				<p class="step-number">Paso 3 de 4</p>
				<ng-template matStepLabel>{{ 'headers.claimConfirm' | translate }}</ng-template>
				<ng-template matStepContent>
					<confirmacion-siniestro (nextStep)="onNextStep()" (showC2CButton)="onShowC2CButton($event)"></confirmacion-siniestro>
				</ng-template>
			</mat-step>

			<mat-step>
				<p class="step-number">Paso 4 de 4</p>
				<ng-template matStepLabel>{{ 'headers.claimRegister' | translate }}</ng-template>
				<ng-template matStepContent>
					<alta-siniestro (nextStep)="onNextStep()" (showC2CButton)="onShowC2CButton($event)"></alta-siniestro>
				</ng-template>
			</mat-step>
		</mat-stepper>
	</div>
</div>
<app-loader></app-loader>
<footer class="footer">
	<div class="container bord-marg">
		<div class="mat-horizontal-content-container">
		<div class="c-footer">
		<nav>
			<a href="{{ 'footer.webMapWeb' | translate }}" target="_blank">{{ 'footer.webMap' | translate }}</a>
			<a href="{{ 'footer.dataProtectionWeb' | translate }}" target="_blank">{{ 'footer.dataProtection' | translate }}</a>
			<a href="{{ 'footer.legalNoticeWeb' | translate }}" target="_blank">{{ 'footer.legalNotice' | translate }}</a>
			<a href="{{ 'footer.cookiesWeb' | translate }}" target="_blank">{{ 'footer.cookies' | translate }}</a>
			<a href="{{ 'footer.accesibilityWeb' | translate }}" target="_blank">{{ 'footer.accesibility' | translate }}</a>
		</nav>
		</div>
	</div>
	</div>
</footer>
